import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retention',
  template: `
  <router-outlet></router-outlet>
`,
  styles: []
})
export class RetentionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/system/retention/retention.component.ts